<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <div class="layout-btn">
      <div class="d-flex align-center pr-3">
        <v-btn
          fab
          dark
          small
          class="color-btn"
          @click="indexShow--"
          :disabled="indexShow === 0 ? true : false"
          ><v-icon size="35">mdi-chevron-left</v-icon></v-btn
        >
      </div>
      <v-card class="layout-card" >
        <!-- <div class="d-flex">
        <div class="ml-auto">
          <v-btn icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </div>
      </div> -->
          <!-- <div class="d-flex content-announce"> -->
          <!-- <div class="d-flex align-center">
            <v-btn
              icon
              color="#4F9F8C"
              @click="indexShow--"
              :disabled="indexShow === 0 ? true : false"
              ><v-icon size="45">mdi-chevron-left</v-icon></v-btn
            >
          </div> -->
          <div style=" min-width: 300px;" >
          <div
            v-for="(item, index) in items"
            :key="index"
            v-show="index === indexShow"
            style="width: 100%; max-height: 72vh"
            class="slide-in-x"
          >
            <div class="output ql-snow">
              <div class="title-show">
                {{ FiltersLanguage(item, "title") }}
              </div>
              <div
                class="ql-editor"
                v-html="FiltersLanguage(item, 'description')"
              ></div>
            </div>
            <!-- <div class="px-5 page--text" style="text-align: center">
                {{ index + 1 }}/{{ items.length }}
              </div> -->
          </div>
          <!-- <div class="d-flex align-center">
            <v-btn
              icon
              color="#4F9F8C"
              @click="indexShow++"
              :disabled="indexShow + 1 === items.length ? true : false"
              ><v-icon size="45"> mdi-chevron-right</v-icon></v-btn
            >
          </div> -->
          <!-- </div> -->
        </div>
      </v-card>
      <div class="d-flex align-center pl-3">
        <v-btn
          fab
          dark
          small
          class="color-btn"
          @click="indexShow++"
          :disabled="indexShow + 1 === items.length ? true : false"
          ><v-icon size="35"> mdi-chevron-right</v-icon></v-btn
        >
      </div>
    </div>
    <div style="width: 100%" class="d-flex justify-center mt-5">
      <v-btn @click="close()" dark class="close-btn mb-5 color-btn" rounded>
        {{ FiltersLanguage(itemCompanyVisit, "btn_close") }}
        &times;</v-btn
      >
    </div>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      indexShow: 0,
      itemCompanyVisit: { btn_close_th: 'ปิด', btn_close_eng: 'close' }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dialog: {
      handler: function (newValue) {
        if (newValue === true) {
          if (this.items.length > 1) {
            this.autoPlay()
          }
        }
      },
      deep: true
    }
  },
  async created () {},
  methods: {
    close () {
      this.dialog = false
      this.$emit('close')
      this.indexShow = 0
      this.languageShow = 'th'
    },
    autoPlay () {
      setTimeout(() => {
        if (this.indexShow >= this.items.length - 1) {
          this.indexShow = 0
        } else {
          this.indexShow++
        }
        if (this.dialog === false) {
          return ''
        }
        this.autoPlay()
      }, 4000)
    }
  }
}
</script>

<style scoped lang="css">
>>> .v-dialog {
  box-shadow: unset !important;
  /* justify-items: center; */
}
.page--text {
  text-align: center;
  font-size: 16px;
  margin-top: 20px;
}
.layout-btn {
  display: flex;
  justify-content: center;
}
.color-btn {
  background-color: rgba(15, 15, 15, 0.7) !important;
}
.layout-card {
  padding: 10px 10px 20px 10px;
  max-height: 80vh;
  overflow-y: auto;
}
/* .content-announce {
  min-width: 400px;
  padding: 20px;
} */

.title-show {
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  /* margin-bottom: 20px; */
}
@media screen and (max-width: 600px) {
  .layout-card {
  padding: 10px 10px 10px 10px;
}
}
</style>
